import {
  docThamSos,
  docTieuChi,
  IMauEmail,
  IMauEmailBien,
  IMauEmailLichSuRequest,
  IMauEmailLichSuResult,
  IMauEmailLocResult,
  IMauEmailSelectRequest,
  IMauEmailXemTruoc,
  tieuChiMacDinh,
} from "../../../api/thiet-lap/mauEmailApi";
import { IMauEmailActionTypes } from "../../action-types/thiet-lap/IMauEmailActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IMauEmailReducer } from "../../reducer-model/thiet-lap/IMauEmailReducer";

const iniState: IMauEmailReducer = {
  statusMau: eReducerStatusBase.is_not_initialization,
  requestMau: { search_key: "", nhom: "", is_su_dung: -1 },
  maus: [],
  isShowMauModal: false,
  biens: [],
  statusBien: eReducerStatusBase.is_not_initialization,

  idMauChon: 0,
  tieuChi: tieuChiMacDinh(),
  tieuDe: "",
  noiDung: "",
  thamSos: [],
  thamSoValues: {},
  statusLoc: eReducerStatusBase.is_not_initialization,
  idSvSelections: [],
  statusGui: eReducerStatusBase.is_completed,

  statusLichSu: eReducerStatusBase.is_not_initialization,
  requestLichSu: {
    id_mau: 0,
    trang_thai: -1,
    page_index: 1,
    page_size: 50,
  },
};

export const mauEmailReducer = (
  state: IMauEmailReducer = iniState,
  action: IMauEmailActionTypes,
): IMauEmailReducer => {
  switch (action.type) {
    // ===== MẪU EMAIL =====
    case "MAU_EMAIL_MAU_CHANGE_REQUEST":
      return {
        ...state,
        requestMau: {
          ...state.requestMau,
          ...(action.payload as Partial<IMauEmailSelectRequest>),
        },
        statusMau: eReducerStatusBase.is_need_reload,
      };
    case "MAU_EMAIL_MAU_LOAD_START":
      return { ...state, statusMau: eReducerStatusBase.is_loading };
    case "MAU_EMAIL_MAU_LOAD_SUCCESS":
      return {
        ...state,
        statusMau: eReducerStatusBase.is_completed,
        maus: (action.payload as IMauEmail[]) ?? [],
      };
    case "MAU_EMAIL_MAU_LOAD_ERROR":
      return { ...state, statusMau: eReducerStatusBase.is_completed };

    case "MAU_EMAIL_MAU_SHOW_MODAL":
      return {
        ...state,
        isShowMauModal: true,
        mauDangSua: action.payload as IMauEmail | undefined,
      };
    case "MAU_EMAIL_MAU_CLOSE_MODAL":
      return { ...state, isShowMauModal: false, mauDangSua: undefined };

    case "MAU_EMAIL_MAU_SAVE_START":
    case "MAU_EMAIL_MAU_DELETE_START":
      return { ...state, statusMau: eReducerStatusBase.is_saving };
    case "MAU_EMAIL_MAU_SAVE_SUCCESS":
      return {
        ...state,
        isShowMauModal: false,
        mauDangSua: undefined,
        statusMau: eReducerStatusBase.is_need_reload,
      };
    case "MAU_EMAIL_MAU_DELETE_SUCCESS":
      return { ...state, statusMau: eReducerStatusBase.is_need_reload };
    case "MAU_EMAIL_MAU_SAVE_ERROR":
    case "MAU_EMAIL_MAU_DELETE_ERROR":
      // Lỗi thì mở lại cửa sổ khai (không đóng) để cán bộ sửa, chỉ bỏ vòng quay.
      return { ...state, statusMau: eReducerStatusBase.is_completed };

    case "MAU_EMAIL_BIEN_LOAD_START":
      return { ...state, statusBien: eReducerStatusBase.is_loading };
    case "MAU_EMAIL_BIEN_LOAD_SUCCESS":
      return {
        ...state,
        statusBien: eReducerStatusBase.is_completed,
        biens: (action.payload as IMauEmailBien[]) ?? [],
      };
    case "MAU_EMAIL_BIEN_LOAD_ERROR":
      return { ...state, statusBien: eReducerStatusBase.is_completed };

    case "MAU_EMAIL_SMTP_LOAD_SUCCESS":
      return { ...state, coCauHinhSmtp: !!action.payload };

    // ===== GỬI =====
    case "MAU_EMAIL_CHON_MAU": {
      const mau = action.payload as IMauEmail | undefined;
      if (!mau) {
        return {
          ...state,
          idMauChon: 0,
          tieuDe: "",
          noiDung: "",
          thamSos: [],
          thamSoValues: {},
          tieuChi: tieuChiMacDinh(),
          // Bỏ luôn kết quả lọc cũ: đổi mẫu là đổi tiêu chí, giữ lại danh sách cũ rất dễ
          // gửi nhầm cho nhóm sinh viên của mẫu trước.
          ketQuaLoc: undefined,
          idSvSelections: [],
          statusLoc: eReducerStatusBase.is_not_initialization,
        };
      }
      const thamSos = docThamSos(mau.tham_so);
      const values: Record<string, string> = {};
      thamSos.forEach((t) => {
        if (t.ma) values[t.ma] = t.gia_tri ?? "";
      });
      return {
        ...state,
        idMauChon: mau.id,
        tieuDe: mau.tieu_de ?? "",
        noiDung: mau.noi_dung ?? "",
        tieuChi: docTieuChi(mau.tieu_chi),
        thamSos,
        thamSoValues: values,
        ketQuaLoc: undefined,
        idSvSelections: [],
        statusLoc: eReducerStatusBase.is_not_initialization,
      };
    }
    case "MAU_EMAIL_CHANGE_TIEU_CHI":
      return {
        ...state,
        tieuChi: { ...state.tieuChi, ...(action.payload as any) },
        // Đổi tiêu chí thì danh sách cũ không còn đúng — buộc lọc lại thay vì để số liệu lẫn.
        ketQuaLoc: undefined,
        idSvSelections: [],
        statusLoc: eReducerStatusBase.is_not_initialization,
      };
    case "MAU_EMAIL_CHANGE_NOI_DUNG":
      return { ...state, ...(action.payload as { tieu_de?: string; noi_dung?: string }) };
    case "MAU_EMAIL_CHANGE_THAM_SO_VALUE": {
      const { ma, gia_tri } = action.payload as { ma: string; gia_tri: string };
      return { ...state, thamSoValues: { ...state.thamSoValues, [ma]: gia_tri } };
    }

    case "MAU_EMAIL_LOC_START":
      return { ...state, statusLoc: eReducerStatusBase.is_loading };
    case "MAU_EMAIL_LOC_SUCCESS": {
      const kq = action.payload as IMauEmailLocResult;
      return {
        ...state,
        statusLoc: eReducerStatusBase.is_completed,
        ketQuaLoc: kq,
        // Tích sẵn TẤT CẢ em vừa lọc ra: đã lọc đúng tiêu chí thì mặc định là gửi hết,
        // cán bộ bỏ tích vài em nhanh hơn tích vài trăm em.
        idSvSelections: (kq?.data ?? []).map((g) => g.id_sv),
      };
    }
    case "MAU_EMAIL_LOC_ERROR":
      return { ...state, statusLoc: eReducerStatusBase.is_completed };

    case "MAU_EMAIL_SELECTED_SV":
      return { ...state, idSvSelections: (action.payload as string[]) ?? [] };

    case "MAU_EMAIL_GUI_START":
    case "MAU_EMAIL_XEM_TRUOC_START":
      return { ...state, statusGui: eReducerStatusBase.is_loading };
    case "MAU_EMAIL_GUI_SUCCESS":
      return {
        ...state,
        statusGui: eReducerStatusBase.is_completed,
        // Gửi xong phải lọc lại: cột "đã nhắc mấy lần" vừa đổi.
        statusLoc: eReducerStatusBase.is_need_reload,
        statusLichSu: eReducerStatusBase.is_need_reload,
      };
    case "MAU_EMAIL_GUI_ERROR":
    case "MAU_EMAIL_XEM_TRUOC_ERROR":
      return { ...state, statusGui: eReducerStatusBase.is_completed };
    case "MAU_EMAIL_XEM_TRUOC_SUCCESS":
      return {
        ...state,
        statusGui: eReducerStatusBase.is_completed,
        xemTruoc: action.payload as IMauEmailXemTruoc,
      };
    case "MAU_EMAIL_DONG_XEM_TRUOC":
      return { ...state, xemTruoc: undefined };

    // ===== LỊCH SỬ =====
    case "MAU_EMAIL_LICHSU_CHANGE_REQUEST":
      return {
        ...state,
        requestLichSu: {
          ...state.requestLichSu,
          ...(action.payload as Partial<IMauEmailLichSuRequest>),
        },
        statusLichSu: eReducerStatusBase.is_need_reload,
      };
    case "MAU_EMAIL_LICHSU_LOAD_START":
      return { ...state, statusLichSu: eReducerStatusBase.is_loading };
    case "MAU_EMAIL_LICHSU_LOAD_SUCCESS":
      return {
        ...state,
        statusLichSu: eReducerStatusBase.is_completed,
        lichSu: action.payload as IMauEmailLichSuResult,
      };
    case "MAU_EMAIL_LICHSU_LOAD_ERROR":
      return { ...state, statusLichSu: eReducerStatusBase.is_completed };

    default:
      return state;
  }
};
